var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/camelcase */
import widgetTransformer from '@nykaa/deals-transformer';
import apiService from './helper';
/**
 * Utility function to update batch state supplied via args and calls the passed callback
 * @param updateBatchStateCallback: Function callback
 * @param batchesMap: Batches Map
 * @param currentBatchToBeExecuted: current batch name
 * @param currentBatchChange: object to change loading and completed state of a batch
 * @param nextBatch?: Next Batch name to be executed
 * @param triggerAtImpressionPosition?: Position GTE at which batch call should be triggered
 */
const updateBatchState = (updateBatchStateCallback, batchesMap, currentBatchToBeExecuted, currentBatchChange, nextBatch, triggerAtImpressionPosition) => {
    const batchInitialState = {
        isBatchLoading: false,
        isBatchCompleted: false,
        isBatchFetchFailed: false,
    };
    if (nextBatch) {
        updateBatchStateCallback(Object.assign(Object.assign({}, batchesMap), { currentBatchToBeExecuted: nextBatch, batches: Object.assign(Object.assign({}, batchesMap.batches), { [currentBatchToBeExecuted]: Object.assign(Object.assign(Object.assign({}, batchesMap.batches[currentBatchToBeExecuted]), batchInitialState), currentBatchChange), [nextBatch]: Object.assign(Object.assign({}, batchesMap.batches[nextBatch]), { triggerAtImpressionPosition }) }) }));
    }
    else {
        updateBatchStateCallback(Object.assign(Object.assign({}, batchesMap), { batches: Object.assign(Object.assign({}, batchesMap.batches), { [currentBatchToBeExecuted]: Object.assign(Object.assign(Object.assign({}, batchesMap.batches[currentBatchToBeExecuted]), batchInitialState), currentBatchChange) }) }));
    }
};
/**
 * Receive impression and decides which batch api to call
 * @param impressions
 * @param apiUtils Utils required to make batch call
 * @param updatePageDataCallback Fn to update total widgetList in the page/isPageFetchCompeleted
 * @param paginationObj Pagination utility object
 * @param updateBatchStateCallback Fn to update individual batch info
 * @param isDesktop
 */
const handlePaginationBasedOnImpression = (impressions, apiUtils, updatePageDataCallback, paginationObj, updateBatchStateCallback, isDesktop) => {
    const { ApiHelper, dealsEndpoint, store, apiParams, } = apiUtils || {};
    const { paginationParams, params, } = apiParams;
    const { page_prefix = '' } = params || {};
    if (params && params.page_prefix) {
        delete params.page_prefix;
    }
    const { isPaginationEnabled, bufferSize } = paginationParams || {};
    const { pageFetchCompleted, batchesMap, totalInventoryCount: inventoryCount, } = paginationObj || {};
    if (!isPaginationEnabled
        || pageFetchCompleted
        || (batchesMap
            && batchesMap.batches
            && !Object.keys(batchesMap.batches).length) // Signifies empty remaining inventry ids
    ) {
        return;
    }
    impressions.map((imp) => __awaiter(void 0, void 0, void 0, function* () {
        if (imp.event && imp.event.indexOf('click') === -1) {
            const { position1 } = imp;
            const { currentBatchToBeExecuted, batches } = batchesMap;
            const currentBatch = batches[currentBatchToBeExecuted];
            if (currentBatch) {
                const { triggerAtImpressionPosition } = currentBatch;
                const { inventoryIds, isBatchCompleted, isBatchLoading, } = currentBatch;
                if (!isBatchLoading && !isBatchCompleted && position1 >= triggerAtImpressionPosition) {
                    params.inventory_ids = inventoryIds.join();
                    updateBatchState(updateBatchStateCallback, batchesMap, currentBatchToBeExecuted, { isBatchLoading: true });
                    try {
                        const result = yield apiService.getPaginatedWidgets(ApiHelper, dealsEndpoint, params);
                        const { widgets = [] } = widgetTransformer(result.inventory_data, isDesktop, store, page_prefix, inventoryCount);
                        const [, batchNumber] = currentBatchToBeExecuted.split('batch');
                        const isPageFetchCompleted = Object.keys(batchesMap.batches).length === +(batchNumber);
                        const nextBatch = `batch${Number(batchNumber) + 1}`;
                        const callbackFn = () => updateBatchState(updateBatchStateCallback, batchesMap, currentBatchToBeExecuted, { isBatchCompleted: true }, nextBatch, inventoryCount + widgets.length - bufferSize);
                        updatePageDataCallback({
                            widgetData: widgets,
                            pageFetchCompleted: isPageFetchCompleted,
                            callbackFn,
                        });
                    }
                    catch (err) {
                        // On error move to next batch until all batch calls are triggered
                        const [, batchNumber] = currentBatchToBeExecuted.split('batch');
                        const nextBatch = `batch${Number(batchNumber) + 1}`;
                        const isPageFetchCompleted = Object.keys(batchesMap.batches).length === +(batchNumber);
                        if (!isPageFetchCompleted) {
                            updateBatchState(updateBatchStateCallback, batchesMap, currentBatchToBeExecuted, { isBatchCompleted: true }, nextBatch, inventoryCount - bufferSize);
                        }
                        else {
                            updateBatchState(updateBatchStateCallback, batchesMap, currentBatchToBeExecuted, { isBatchLoading: false, isBatchCompleted: true });
                        }
                    }
                }
            }
        }
    }));
};
/**
 * Convert remainingInventoriesIds into batches
 * @param initialInventoryCount: Initial inventories received in first call
 * @param remainingInventoriesIds: Remaining inventories to be call subsequently
 * @param bufferSize  limit for SDK to initiate pagination call
 * @param limit  number of inventories to be fetched in pagination call
 */
const processRemainingInventories = (initialInventoryCount, remainingInventoriesIds, bufferSize, limit) => {
    const pageLimit = remainingInventoriesIds.length < limit ? remainingInventoriesIds.length : limit;
    const batches = remainingInventoriesIds.reduce((acc, curr, currIndex) => {
        if (((currIndex * pageLimit) + pageLimit)
            <= Math.ceil(remainingInventoriesIds.length / pageLimit) * pageLimit) {
            acc[`batch${currIndex + 1}`] = {
                inventoryIds: remainingInventoriesIds.slice(currIndex * pageLimit, (currIndex * pageLimit) + pageLimit),
                isBatchLoading: false,
                isBatchCompleted: false,
                isBatchFetchFailed: false,
                triggerAtImpressionPosition: currIndex === 0 ? (initialInventoryCount - bufferSize) : NaN,
            };
            return acc;
        }
        return acc;
    }, {});
    const batchesMap = {
        currentBatchToBeExecuted: 'batch1',
        batches,
    };
    return { batchesMap };
};
/**
 * Makes batch api call if no impression is encountered in DN Instance
 * @param batchesMap
 * @param apiUtils
 * @param paginationObj
 * @param isDesktop
 * @param updateBatchStateCallback
 * @param updatePageDataCallback
 */
const handleImmediatePaginationCall = (batchesMap, apiUtils, paginationObj, isDesktop, updateBatchStateCallback, updatePageDataCallback) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { ApiHelper, dealsEndpoint, store, apiParams, } = apiUtils;
    const { paginationParams, params, } = apiParams;
    const { bufferSize } = paginationParams;
    const { totalInventoryCount: inventoryCount } = paginationObj;
    const { pagePrefix } = params;
    const { inventoryIds = [], isBatchLoading, isBatchCompleted } = ((_a = batchesMap === null || batchesMap === void 0 ? void 0 : batchesMap.batches) === null || _a === void 0 ? void 0 : _a.batch1) || {};
    if (isBatchLoading || isBatchCompleted) {
        return;
    }
    params.inventory_ids = inventoryIds.join();
    try {
        updateBatchState(updateBatchStateCallback, batchesMap, 'batch1', { isBatchLoading: true });
        const result = yield apiService.getPaginatedWidgets(ApiHelper, dealsEndpoint, params);
        const { widgets = [] } = widgetTransformer(result.inventory_data, isDesktop, store, pagePrefix, inventoryCount);
        const isPageFetchCompleted = Object.keys(batchesMap.batches).length === 1;
        const nextBatch = 'batch2';
        const callbackFn = () => updateBatchState(updateBatchStateCallback, batchesMap, 'batch1', { isBatchCompleted: true }, nextBatch, inventoryCount + widgets.length - bufferSize);
        updatePageDataCallback({
            widgetData: widgets,
            pageFetchCompleted: isPageFetchCompleted,
            callbackFn,
        });
    }
    catch (err) {
        updateBatchState(updateBatchStateCallback, batchesMap, 'batch1', { isBatchFetchFailed: false });
    }
});
export default {
    handlePaginationBasedOnImpression,
    processRemainingInventories,
    handleImmediatePaginationCall,
};
